// Portrait video card: custom olive play/pause and mute controls over a native <video>.
// Buttons use commandfor/command (--toggle-play, --toggle-mute) targeting this element.
// Never autoplays; starts muted. Playing one card pauses every other card on the page.
const instances = new Set();

class SPortraitVideo extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    if (!this.video) return;
    this.controller = new AbortController();
    const { signal } = this.controller;
    instances.add(this);

    this.video.muted = true;
    this.video.playsInline = true;
    this.video.removeAttribute('autoplay');

    this.addEventListener('command', (event) => {
      if (event.command === '--toggle-play') this.togglePlay();
      if (event.command === '--toggle-mute') this.toggleMute();
    }, { signal });

    this.video.addEventListener('play', () => {
      instances.forEach((other) => { if (other !== this) other.pause(); });
      this.sync();
    }, { signal });
    this.video.addEventListener('pause', () => this.sync(), { signal });
    this.video.addEventListener('ended', () => this.sync(), { signal });
    this.video.addEventListener('volumechange', () => this.sync(), { signal });
    this.sync();
  }

  togglePlay() {
    if (this.video.paused) {
      this.video.play().catch(() => this.sync());
    } else {
      this.video.pause();
    }
  }

  toggleMute() {
    this.video.muted = !this.video.muted;
  }

  pause() {
    if (this.video && !this.video.paused) this.video.pause();
  }

  sync() {
    const playing = !this.video.paused && !this.video.ended;
    this.toggleAttribute('data-playing', playing);
    this.toggleAttribute('data-muted', this.video.muted);
    const playButton = this.querySelector('[data-play-button]');
    if (playButton) playButton.setAttribute('aria-label', playing ? this.dataset.labelPause : this.dataset.labelPlay);
    const muteButton = this.querySelector('[data-mute-button]');
    if (muteButton) muteButton.setAttribute('aria-label', this.video.muted ? this.dataset.labelUnmute : this.dataset.labelMute);
  }

  disconnectedCallback() {
    this.controller?.abort();
    instances.delete(this);
  }
}

if (!customElements.get('s-portrait-video')) customElements.define('s-portrait-video', SPortraitVideo);
